import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CategoryIcon from '@material-ui/icons/Category';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ExtensionIcon from '@material-ui/icons/Extension';
import TimelineIcon from '@material-ui/icons/Timeline';
import { CatalogIcon, DocsIcon } from '@backstage/core-components';
import { CatalogSearchResultListItem } from '@backstage/plugin-catalog';
import {
  HomePageCompanyLogo,
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageRecentlyVisited,
  HomePageTopVisited,
  VisitDisplayProvider,
  WelcomeTitle,
} from '@backstage/plugin-home';
import {
  SearchBar,
  SearchContextProvider,
  SearchResult,
  useSearch,
} from '@backstage/plugin-search-react';
import { TechDocsSearchResultListItem } from '@backstage/plugin-techdocs';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(3, 6),
  },
  searchResults: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 0),
  },
}));

const tools = [
  { label: 'Catalog', url: '/catalog', icon: <CategoryIcon /> },
  { label: 'Tech Radar', url: '/tech-radar', icon: <TrackChangesIcon /> },
  { label: 'Dependencies', url: '/dependency-explorer', icon: <AccountTreeIcon /> },
  { label: 'Docs', url: '/docs', icon: <LibraryBooksIcon /> },
  { label: 'Lifecycle', url: '/lifecycle', icon: <TimelineIcon /> },
  { label: 'APIs', url: '/api-docs', icon: <ExtensionIcon /> },
];

const LiveSearchResults = () => {
  const classes = useStyles();
  const { term } = useSearch();
  if (!term) return null;
  return (
    <Paper className={classes.searchResults}>
      <SearchResult>
        <CatalogSearchResultListItem icon={<CatalogIcon />} />
        <TechDocsSearchResultListItem icon={<DocsIcon />} />
      </SearchResult>
    </Paper>
  );
};

export const HomePage = () => {
  const classes = useStyles();
  return (
    <VisitDisplayProvider>
      <div className={classes.container}>
        <Grid container spacing={3} alignItems="stretch">

          {/* Logo + Welcome */}
          <Grid item xs={12} md={3} style={{ display: 'flex' }}>
            <HomePageCompanyLogo />
          </Grid>
          <Grid item xs={12} md={9} style={{ display: 'flex', alignItems: 'center' }}>
            <WelcomeTitle variant="h3" language={['English', 'German']} />
          </Grid>

          {/* Live Search */}
          <Grid item xs={12}>
            <SearchContextProvider>
              <SearchBar />
              <LiveSearchResults />
            </SearchContextProvider>
          </Grid>

          {/* Quick links + Starred */}
          <Grid item xs={12} md={6}>
            <HomePageToolkit tools={tools} />
          </Grid>
          <Grid item xs={12} md={6}>
            <HomePageStarredEntities />
          </Grid>

          {/* Visit history */}
          <Grid item xs={12} md={6}>
            <HomePageRecentlyVisited />
          </Grid>
          <Grid item xs={12} md={6}>
            <HomePageTopVisited />
          </Grid>

        </Grid>
      </div>
    </VisitDisplayProvider>
  );
};
